module.exports = __webpack_public_path__ + "static/media/home_screen_.4242919d.png";